"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const images_1 = require("../../services/images");
const lodash_1 = require("lodash");
const InputWeb = ({ value, onChange, name, label, type = "text", showError = false, showPasswordEye = false, errorMessage = {}, validate = () => null, placeholder, isDisabled = false, }) => {
    const handleChange = (event) => {
        const updatedValue = event.target.value;
        if (type === 'number' && (0, lodash_1.isString)(updatedValue)) {
            const parsedValue = parseInt(updatedValue, 10);
            if (Number.isInteger(parsedValue) && parsedValue > 0) {
                onChange(prevState => ({ ...prevState, [name]: parsedValue }));
            }
        }
        else
            onChange(prevState => ({ ...prevState, [name]: updatedValue }));
    };
    const [error, setError] = (0, react_1.useState)(false);
    const [passwordType, setPasswordType] = (0, react_1.useState)("password");
    const togglePassword = () => {
        if (passwordType === "password") {
            setPasswordType("text");
            return;
        }
        setPasswordType("password");
    };
    return ((0, jsx_runtime_1.jsxs)("div", { className: `input-box ${error ? 'has-error' : ''}`, children: [(0, jsx_runtime_1.jsxs)("label", { className: `input-label ${isDisabled ? 'disabled' : ''}`, children: [label, (0, jsx_runtime_1.jsx)("input", { className: showPasswordEye ? "input-web password" : "input-web", value: value[name], type: type === "password" ? passwordType : type, placeholder: placeholder, onChange: handleChange, disabled: isDisabled, onBlur: () => {
                            showError && setError(value[name].length !== 0 && validate(value[name]));
                        } }), showPasswordEye &&
                        (0, jsx_runtime_1.jsx)("span", { className: "password-eye", onClick: togglePassword, children: (0, jsx_runtime_1.jsx)("img", { src: passwordType === "password" ? images_1.icons.PasswordOffEye : images_1.icons.PasswordEye, alt: "password eye" }) })] }), error && typeof error == "string" && errorMessage &&
                (0, jsx_runtime_1.jsx)("label", { className: "error-message", children: errorMessage[error] })] }));
};
exports.default = InputWeb;
